import { Button, Card, Slide, SlideProps, Snackbar, TextField } from '@material-ui/core';
import type { FC } from 'react';
import React, { useEffect } from 'react';
import type { ProductType } from '../types';
import TransferForm from '../Forms/TransferForm';
import HotelForm from '../Forms/HotelForm';
import TicketForm from '../Forms/TicketForm';
import InsuranceForm from '../Forms/InsuranceForm';
import { Grid } from '@material-ui/core';
import { CardContent } from '@material-ui/core';
import { HotelInput, Partner } from '../Forms/HotelForm/types';
import { TransferInput } from '../Forms/TransferForm/types';
import { InsuranceInput } from '../Forms/InsuranceForm/types';
import { TicketInput } from '../Forms/TicketForm/types';
import Summary from '../Summary';
import ExtraForm from '../Forms/ExtraForm';
import { ExtraInput } from '../Forms/ExtraForm/types';
import ProductTabs from '../Components/ProductTabs/ProductTabs';
import { usePackage } from '../hooks/usePackage';
import { PackageActionType } from '../hooks/types';
import { useParams } from 'react-router';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { usePartnersQuery } from '../graphql/partners.generated';
import { Link } from 'react-router-dom';

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="up" />;
}

type EditValues = {
  hotel?: HotelInput;
  ticket?: TicketInput;
  transfer?: TransferInput;
  insurance?: InsuranceInput;
  extra?: ExtraInput;
};

const EditPackage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const [activeProduct, setActiveProduct] = React.useState<ProductType>();
  const [editValues, setEditValues] = React.useState<EditValues>({});
  const [open, setOpen] = React.useState(false);
  const [action, setAction] = React.useState<'CREATE' | 'EDIT'>();
  const { state, dispatch } = usePackage(id || '');
  const [packageName, setPackageName] = React.useState<string>('');
  const [totalAmount, setTotalAmount] = React.useState<number>(0);
  const { data: partnersData } = usePartnersQuery();
  const partners = partnersData?.getPartners || [];
  const partnerOptions: Array<{ label: string; value: Partner }> =
    partners.map((partner) => ({ label: partner?.name || '', value: partner })) || [];

  useEffect(() => {
    if (packageName !== state.packageName) {
      setPackageName(state.packageName || '');
    }

    if (state.total !== totalAmount) {
      setTotalAmount(state.total);
    }
  }, [state.packageName, state.total]);

  console.log({ editValues, activeProduct });

  const handleSuccess = () => {
    setActiveProduct(undefined);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  console.log({ state });

  const handlePackageNameBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    dispatch({
      type: PackageActionType.SET_PACKAGE_NAME,
      payload: event.target.value
    });
  };

  const onCustomerDepositDateChange = (date: Date | null) => {
    if (!date) return;
    dispatch({
      type: PackageActionType.UPSERT_CUSTOMER_PAYMENT,
      payload: { depositDate: date }
    });
  };

  const onCustomerTotalDateChange = (date: Date | null) => {
    if (!date) return;
    dispatch({
      type: PackageActionType.UPSERT_CUSTOMER_PAYMENT,
      payload: { totalDate: date }
    });
  };

  const onTotalAmountChange = (amount: number) => {
    dispatch({
      type: PackageActionType.UPSERT_CUSTOMER_PAYMENT,
      payload: { totalAmount: amount }
    });
  };

  const onHotelSubmit = (values: HotelInput) => {
    if (action === 'EDIT' && editValues.hotel?.id) {
      dispatch({
        type: PackageActionType.EDIT_HOTEL,
        payload: {
          id: editValues.hotel.id,
          values
        }
      });
    } else {
      console.log({ values });
      dispatch({
        type: PackageActionType.ADD_HOTEL,
        payload: values
      });
    }
  };

  const onTransferSubmit = (values: TransferInput) => {
    if (action === 'EDIT' && editValues.transfer?.id) {
      dispatch({
        type: PackageActionType.EDIT_TRANSFER,
        payload: {
          id: editValues.transfer.id,
          values
        }
      });
    } else {
      dispatch({
        type: PackageActionType.ADD_TRANSFER,
        payload: values
      });
    }
  };

  const onInsuranceSubmit = (values: InsuranceInput) => {
    if (action === 'EDIT' && editValues.insurance?.id) {
      dispatch({
        type: PackageActionType.EDIT_INSURANCE,
        payload: {
          id: editValues.insurance.id,
          values
        }
      });
    } else {
      dispatch({
        type: PackageActionType.ADD_INSURANCE,
        payload: values
      });
    }
  };

  const onTicketSubmit = (values: TicketInput) => {
    if (action === 'EDIT' && editValues.ticket?.id) {
      dispatch({
        type: PackageActionType.EDIT_TICKET,
        payload: {
          id: editValues.ticket.id,
          values
        }
      });
    } else {
      dispatch({
        type: PackageActionType.ADD_TICKET,
        payload: values
      });
    }
  };

  const onExtraSubmit = (values: ExtraInput) => {
    if (action === 'EDIT' && editValues.extra?.id) {
      dispatch({
        type: PackageActionType.EDIT_EXTRA,
        payload: {
          id: editValues.extra.id,
          values
        }
      });
    } else {
      dispatch({
        type: PackageActionType.ADD_EXTRA,
        payload: values
      });
    }
  };

  const handlePackageNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPackageName(event.target.value);
  };

  const handleDelete = (id: string, productType: ProductType) => {
    resetStates();
    setActiveProduct(undefined);
    if (productType === 'hotel') {
      dispatch({
        type: PackageActionType.REMOVE_HOTEL,
        payload: {
          id
        }
      });
    } else if (productType === 'ticket') {
      dispatch({
        type: PackageActionType.REMOVE_TICKET,
        payload: {
          id
        }
      });
    } else if (productType === 'transfer') {
      dispatch({
        type: PackageActionType.REMOVE_TRANSFER,
        payload: {
          id
        }
      });
    } else if (productType === 'insurance') {
      dispatch({
        type: PackageActionType.REMOVE_INSURANCE,
        payload: {
          id
        }
      });
    } else if (productType === 'extra') {
      dispatch({
        type: PackageActionType.REMOVE_EXTRA,
        payload: {
          id
        }
      });
    }

    console.log({ activeProduct, editValues });
  };

  const handleSummaryItemClick = async (id: string, productType: ProductType) => {
    if (productType === 'hotel') {
      const values = state.hotels.find((hotel) => id === hotel.id);
      if (values) {
        setEditValues({ hotel: values });
        setActiveProduct('hotel');
        setAction('EDIT');
      }
    } else if (productType === 'ticket') {
      const values = state.tickets.find((ticket) => id === ticket.id);
      if (values) {
        setEditValues({
          ticket: { ...values, departure: { reference: values.departure.reference || '', date: new Date(values.departure.date) } }
        });
        setActiveProduct('ticket');
        setAction('EDIT');
      }
    } else if (productType === 'transfer') {
      const values = state.transfers.find((transfer) => id === transfer.id);
      if (values) {
        setEditValues({ transfer: values });
        setActiveProduct('transfer');
        setAction('EDIT');
      }
    } else if (productType === 'insurance') {
      const values = state.insurances.find((insurance) => id === insurance.id);
      if (values) {
        setEditValues({ insurance: values });
        setActiveProduct('insurance');
        setAction('EDIT');
      }
    } else if (productType === 'extra') {
      const values = state.extras.find((extra) => id === extra.id);
      if (values) {
        setEditValues({ extra: values });
        setActiveProduct('extra');
        setAction('EDIT');
      }
    }
  };

  const renderProductForm = () => {
    if (activeProduct) {
      const config = {
        hotel: (
          <HotelForm
            partnerOptions={partnerOptions}
            initialValues={editValues.hotel}
            submitLabel={action === 'EDIT' ? 'Update booking' : 'Add booking'}
            onSubmit={onHotelSubmit}
            onSuccess={handleSuccess}
          />
        ),
        ticket: (
          <>
            <TicketForm
              partnerOptions={partnerOptions}
              initialValues={editValues.ticket}
              submitLabel={action === 'EDIT' ? 'Update ticket' : 'Add ticket'}
              onSubmit={onTicketSubmit}
              onSuccess={handleSuccess}
            />
          </>
        ),
        transfer: (
          <TransferForm
            partnerOptions={partnerOptions}
            initialValues={editValues.transfer}
            submitLabel={action === 'EDIT' ? 'Update transfer' : 'Add transfer'}
            onSubmit={onTransferSubmit}
            onSuccess={handleSuccess}
          />
        ),
        insurance: (
          <InsuranceForm
            partnerOptions={partnerOptions}
            initialValues={editValues.insurance}
            submitLabel={action === 'EDIT' ? 'Update insurance' : 'Add insurance'}
            onSubmit={onInsuranceSubmit}
            onSuccess={handleSuccess}
          />
        ),
        extra: (
          <ExtraForm
            initialValues={editValues.extra}
            submitLabel={action === 'EDIT' ? 'Update extra' : 'Add extra'}
            onSubmit={onExtraSubmit}
            onSuccess={handleSuccess}
          />
        )
      };

      return (
        <Card style={{ marginTop: '2rem', border: '1px solid #ccc' }}>
          <CardContent>{config[activeProduct]}</CardContent>
        </Card>
      );
    }

    return null;
  };

  const resetStates = () => {
    setEditValues({});
    setAction('CREATE');
  };

  const handleTabChange = (value: ProductType) => {
    setActiveProduct(value);
    resetStates();
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold my-6">Edit package</h1>
        <Link to={`/packages/${id}`}>
          <Button color="primary" variant="outlined">
            Package details
          </Button>
        </Link>
      </div>
      <Grid container spacing={4}>
        <Grid item xs={12} md={7} className="mt-8 mb-2">
          <TextField
            label="Package name"
            id="outlined-number"
            className="w-full"
            size="small"
            value={packageName}
            variant="outlined"
            onChange={handlePackageNameChange}
            onBlur={handlePackageNameBlur}
          />
        </Grid>

        <Grid item xs={12} md={7}>
          <ProductTabs value={activeProduct} setValue={handleTabChange} />
          {renderProductForm()}
        </Grid>
        <Grid item xs={12} md={5}>
          <div>
            <Summary onDelete={handleDelete} onItemClick={handleSummaryItemClick} packageState={state} />
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Card className="mt-8 px-3 py-2 border border-gray-300 flex flex-col">
                <div className="text-xl font-bold py-2">Customer payment</div>
                <Grid item xs={12}>
                  <KeyboardDatePicker
                    format="dd/MM/yyyy"
                    onFocus={() => {}}
                    margin="normal"
                    id="date-picker-inline"
                    label="Deposit date"
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                    name="depositDate"
                    style={{ width: '100%' }}
                    inputVariant="outlined"
                    value={state.depositDate}
                    onChange={onCustomerDepositDateChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <KeyboardDatePicker
                    format="dd/MM/yyyy"
                    onFocus={() => {}}
                    margin="normal"
                    style={{ width: '100%' }}
                    id="date-picker-inline"
                    label="Full payment date"
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                    name="totalDate"
                    inputVariant="outlined"
                    value={state.totalDate}
                    onChange={onCustomerTotalDateChange}
                  />
                </Grid>
                <TextField
                  style={{ marginTop: '1rem' }}
                  id="outlined-number"
                  value={totalAmount}
                  label="Total amount"
                  onChange={(e) => setTotalAmount(Number(e.target.value))}
                  onBlur={(e) => onTotalAmountChange(Number(e.target.value))}
                  variant="outlined"
                  type="number"
                  onWheel={(e) => {
                    // Prevent the input value change
                    (e.target as HTMLInputElement).blur();;
                  }}
                />
              </Card>
            </MuiPickersUtilsProvider>
          </div>
        </Grid>
      </Grid>
      <Snackbar
        open={open}
        TransitionComponent={SlideTransition}
        onClose={handleClose}
        autoHideDuration={3000}
        message="Item added"
      />
    </div>
  );
};

export default EditPackage;
